import { useCallback } from 'react';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useSendParticipantStateCallback } from '../../session/messages/useSendParticipantStateCallback';
import { UserType } from '../../types';
import { providerShortIdAtom } from '../state';

export function useSendProviderParticipantStateCallback() {
  const getProviderShortId = useAtomCallbackMemoized((get) => get(providerShortIdAtom), []);

  const sendParticipantState = useSendParticipantStateCallback();

  return useCallback(async () => {
    await sendParticipantState({
      entityId: getProviderShortId()!,
      entityType: UserType.PROVIDER,
    });
  }, [sendParticipantState, getProviderShortId]);
}
